import { CommentImageList } from "./styles";
import {FC, useCallback, useMemo} from "react";
import {Colors} from "@brg/ui";
import {getCorrectNameFromNumber} from "../../helpers/utils/getCorrectNameFormNumber";
import styled from "styled-components";
import ResizedImageEnhanced from "../../components/ResizedImageEnhanced";
import {useModal} from "../../../core";
import { FormatLinkedText } from "brg-longread";

const CommentItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const CommentName = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
`

const CommentBlock = styled.div`
  display: flex;
  background: ${Colors.galBlack5};
  padding: 12px 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`

const CommentText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
`

const CommentDate = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  color: ${Colors.galBlack47};
  text-align: right;
`

export const CommentHomeworkItem: FC<{comment: any}> = ({comment}) => {

    const modal = useModal();

    const commentTime = useMemo(() => {

        const date = new Date(comment?.created)
        const dateNow = new Date()

        const secondsDifference = Math.ceil((dateNow.getTime() - date.getTime()) / 1000);

        if (secondsDifference < 60) return `${secondsDifference} ${getCorrectNameFromNumber(secondsDifference, ['секунд', 'секунда', 'секунды'])} назад`
        if (secondsDifference < 3600) {
            const minutesDifference = Math.floor(secondsDifference / 60)
            return `${minutesDifference} ${getCorrectNameFromNumber(minutesDifference, ['минут', 'минута', 'минуты'])} назад`
        }
        if (secondsDifference < (3600 * 24)) {
            const hoursDifference = Math.floor(secondsDifference / 60 / 60)
            return `${Math.floor(hoursDifference)} ${getCorrectNameFromNumber(hoursDifference, ['часов', 'час', 'часа'])}  назад`
        }

        const formattedDate = new Date().toLocaleDateString();
        const formattedTime = new Date().toLocaleTimeString().split(':');

        return `${formattedDate} ${formattedTime[0]}:${formattedTime[1]}`
    }, [comment?.created])

    // @ts-ignore
    const openAttachment = useCallback((attachmentId) => {

        modal.show('previewer', {
            activeAttachmentId: attachmentId,
            attachmentList: comment?.attachments || []
        })
    }, [comment?.attachments])

    return <CommentItem>
        <CommentName>{`${comment?.account?.name} ${comment?.account?.surName}`}</CommentName>
        <CommentBlock>
            <CommentText><FormatLinkedText text={comment?.text}/></CommentText>
            <CommentImageList fullWidth>
                {comment?.attachments?.map((attachment: any) => <ResizedImageEnhanced onClick={() => openAttachment(attachment?.attachmentId)} files={attachment?.files}/>)}
            </CommentImageList>
            <CommentDate>{commentTime}</CommentDate>
        </CommentBlock>
    </CommentItem>
}import { CommentImageList } from "./styles";
import {FC, useCallback, useMemo} from "react";
import {Colors} from "@brg/ui";
import {getCorrectNameFromNumber} from "../../helpers/utils/getCorrectNameFormNumber";
import styled from "styled-components";
import ResizedImageEnhanced from "../../components/ResizedImageEnhanced";
import {useModal} from "../../../core";
import { FormatLinkedText } from "brg-longread";

const CommentItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`

const CommentName = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px; 
  letter-spacing: -0.02em;
`

const CommentBlock = styled.div`
  display: flex;
  background: ${Colors.galBlack5};
  padding: 12px 16px;
  flex-direction: column;
  gap: 16px;
  align-self: stretch;
`

const CommentText = styled.div`
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
`

const CommentDate = styled.div`
  font-size: 10px;
  font-weight: 500;
  line-height: 15px;
  color: ${Colors.galBlack47};
  text-align: right;
`

export const CommentHomeworkItem: FC<{comment: any}> = ({comment}) => {

    const modal = useModal();

    const commentTime = useMemo(() => {

        const date = new Date(comment?.created)
        const dateNow = new Date()

        const secondsDifference = Math.ceil((dateNow.getTime() - date.getTime()) / 1000);

        if (secondsDifference < 60) return `${secondsDifference} ${getCorrectNameFromNumber(secondsDifference, ['секунд', 'секунда', 'секунды'])} назад`
        if (secondsDifference < 3600) {
            const minutesDifference = Math.floor(secondsDifference / 60)
            return `${minutesDifference} ${getCorrectNameFromNumber(minutesDifference, ['минут', 'минута', 'минуты'])} назад`
        }
        if (secondsDifference < (3600 * 24)) {
            const hoursDifference = Math.floor(secondsDifference / 60 / 60)
            return `${Math.floor(hoursDifference)} ${getCorrectNameFromNumber(hoursDifference, ['часов', 'час', 'часа'])}  назад`
        }

        const formattedDate = new Date().toLocaleDateString();
        const formattedTime = new Date().toLocaleTimeString().split(':');

        return `${formattedDate} ${formattedTime[0]}:${formattedTime[1]}`
    }, [comment?.created])

    // @ts-ignore
    const openAttachment = useCallback((attachmentId) => {

        modal.show('previewer', {
            activeAttachmentId: attachmentId,
            attachmentList: comment?.attachments || []
        })
    }, [comment?.attachments])

    return <CommentItem>
        <CommentName>{`${comment?.account?.name} ${comment?.account?.surName}`}</CommentName>
        <CommentBlock>
            <CommentText><FormatLinkedText text={comment?.text}/></CommentText>
            <CommentImageList fullWidth>
                {comment?.attachments?.map((attachment: any) => <ResizedImageEnhanced onClick={() => openAttachment(attachment?.attachmentId)} files={attachment?.files}/>)}
            </CommentImageList>
            <CommentDate>{commentTime}</CommentDate>
        </CommentBlock>
    </CommentItem>
}